import api, { unwrap } from './client';

export const getTimeEffective = (tenantId, year) =>
  unwrap(api.get(`/hr/time-effective/${tenantId}/${year}`));

export const upsertTimeEffective = (tenantId, year, personId, payload) =>
  unwrap(api.patch(`/hr/time-effective/${tenantId}/${year}/${personId}`, payload));

export const bulkUpdateTimeEffective = (tenantId, year, payload) =>
  unwrap(api.post(`/hr/time-effective/${tenantId}/${year}/bulk-update`, payload));

export const copyTimeEffectiveYear = (tenantId, fromYear, toYear, overwrite = false) =>
  unwrap(api.post(`/hr/time-effective/${tenantId}/copy-year`, {
    from_year: fromYear, to_year: toYear, overwrite,
  }));
